export const MapQueryName = {
  utmSource: 'utm_source',
  utmMedium: 'utm_medium',
  utmCampaign: 'utm_campaign',
  utmContent: 'utm_content',
  utmTerm: 'utm_term'
}

export const MapTransliterationVariable = [
  ['а', 'a'],
  ['б', 'b'],
  ['в', 'v'],
  ['г', 'g'],
  ['д', 'd'],
  ['е', 'e'],
  ['є', 'e'],
  ['ё', 'e'],
  ['ж', 'j'],
  ['з', 'z'],
  ['и', 'i'],
  ['ї', 'yi'],
  ['й', 'i'],
  ['к', 'k'],
  ['л', 'l'],
  ['м', 'm'],
  ['н', 'n'],
  ['о', 'o'],
  ['п', 'p'],
  ['р', 'r'],
  ['с', 's'],
  ['т', 't'],
  ['у', 'u'],
  ['ф', 'f'],
  ['х', 'h'],
  ['ц', 'c'],
  ['ч', 'ch'],
  ['ш', 'sh'],
  ['щ', 'shch'],
  ['ы', 'y'],
  ['э', 'e'],
  ['ю', 'u'],
  ['я', 'ya']
]

export const MapUTMSystems = {
  yourValues: {
    utmSource: '',
    utmMedium: '',
    utmCampaign: '',
    utmContent: '',
    utmTerm: ''
  },
  googleAds: {
    utmSource: 'google',
    utmMedium: 'cpc',
    utmCampaign: '',
    utmContent: '',
    utmTerm: ''
  },
  yandexDirect: {
    utmSource: 'yandex',
    utmMedium: 'cpc',
    utmCampaign: '',
    utmContent: '',
    utmTerm: ''
  },
  vkontakte: {
    utmSource: 'vkontakte',
    utmMedium: 'cpc',
    utmCampaign: '',
    utmContent: '',
    utmTerm: ''
  },
  vkAds: {
    utmSource: 'vkAds',
    utmMedium: 'cpc',
    utmCampaign: '',
    utmContent: '',
    utmTerm: ''
  },
  mytarget: {
    utmSource: 'mycom',
    utmMedium: 'cpc',
    utmCampaign: '',
    utmContent: '',
    utmTerm: ''
  }
}
